/**
 * useGalleryUploads — GAL-8 React binding for the module-level
 * upload manager.
 *
 * useSyncExternalStore against the engine's cached snapshot, so any
 * component (the tray, an editor button spinner) re-renders on
 * progress without owning any upload state — the manager keeps
 * running when they unmount.
 */
import { useSyncExternalStore } from 'react';
import {
  galleryUploads,
  type EngineSnapshot,
} from '@/lib/uploads/galleryUploadManager';

export function useGalleryUploads(): EngineSnapshot {
  return useSyncExternalStore(galleryUploads.subscribe, galleryUploads.getSnapshot);
}

/** True while any batch for this gallery is still unsettled — the
 *  editor/tab use it to keep their "Add media" spinners honest. */
export function useGalleryUploading(galleryId: string | undefined): boolean {
  const snapshot = useGalleryUploads();
  if (!galleryId) return false;
  return snapshot.batches.some((b) => b.galleryId === galleryId && !b.settled);
}
